'use client';
import React from 'react';
import { useTranslation } from 'next-i18next';
import { FilterOptionKeys, FilterOptions, MenuType, ProductCounters, SearchParams } from '@mybestbrands/types';
import { FiltersModal } from '@/app/ui/components/filters/mobile/FiltersModal';
import { CategoriesModal } from '@/app/ui/components/filters/mobile/CategoriesModal';
import styles from '@/app/ui/components/filters/mobile/style.module.scss';
import { Sliders, UiChecksGrid } from 'react-bootstrap-icons';
import { selectedFilterCount } from '@/app/helpers/searchparams';

interface Props {
  categories: MenuType[] | undefined | null;
  facets: FilterOptions | null;
  searchParams: SearchParams;
  counters: ProductCounters | null;
  disabledFilters?: FilterOptionKeys[];
}

const MODALS = {
  CATEGORIES: 'categories',
  FILTERS: 'filters',
} as const;

type ModalKey = (typeof MODALS)[keyof typeof MODALS];

export function MobileFilterIcons({ categories, facets, searchParams, counters, disabledFilters }: Props) {
  const { t } = useTranslation(['filters']);

  const [activeModal, setActiveModal] = React.useState<ModalKey | null>(null);

  //Show counter badge if category filter is applied
  const isCategoryFilterApplied = !!searchParams?.filters?.categories?.length;
  const filtersCount = selectedFilterCount(searchParams, [FilterOptionKeys.GENDERS]);

  const openModal = (modal: ModalKey) => {
    setActiveModal(modal);
  };
  const closeModal = () => setActiveModal(null);

  return (
    <>
      <div className="d-flex justify-content-end">
        {(categories?.length ?? 0) > 0 && (
          <div
            className="d-flex align-items-center col-6 justify-content-center"
            onClick={() => openModal(MODALS.CATEGORIES)}>
            <UiChecksGrid size={18} />

            <strong className="ms-1" style={{ fontSize: '18px' }}>
              {t('filters:categories')}
            </strong>
            {isCategoryFilterApplied && <span className={`mb-4 ${styles.filterbadge}`}>1</span>}
          </div>
        )}

        <div
          className="d-flex align-items-center col-6 justify-content-center"
          onClick={() => openModal(MODALS.FILTERS)}>
          <Sliders size={18} />
          <strong className="ms-1" style={{ fontSize: '18px' }}>
            {t('filters:FILTERS')}
          </strong>
          {filtersCount > 0 && <span className={`mb-4 ${styles.filterbadge}`}>{filtersCount}</span>}
        </div>
      </div>
      <CategoriesModal categories={categories} isVisible={activeModal === MODALS.CATEGORIES} onClose={closeModal} />
      <FiltersModal
        counters={counters}
        searchParams={searchParams}
        facets={facets}
        isVisible={activeModal === MODALS.FILTERS}
        onClose={closeModal}
        disabledFilters={disabledFilters}
        // showCategories={closeModal}
      />
    </>
  );
}
